import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import Home from '@routes/Home/routes/Curriculum/routes/DashboardHome';
import StudentsListRoute from '@routes/Home/routes/Curriculum/routes/DashboardHome/StudentsList';
import HomeAnalytics from '@routes/Home/routes/Curriculum/routes/HomeAnalytics';
import MyClasses from '@routes/Home/routes/Curriculum/routes/MyClasses';
import { NAME, reducer } from '@routes/Home/routes/Curriculum/modules/Module';
import AttendanceDashboard from './routes/DashboardHome/AttendanceDashboard';
import Circular from './routes/DashboardHome/Circular';
import ClassDetails from './routes/ClassDetails';
import GradeBook from './routes/GradeBook';
import HomeTimeTable from './routes/DashboardHome/HomeTimeTable';
import MediaLog from './routes/DashboardHome/MediaLog';
import Insights from './routes/DashboardHome/Insights';
import TeacherNotes from './routes/DashboardHome/TeacherNotes';
import Transport from './routes/DashboardHome/Transport';
import Fees from './routes/DashboardHome/Fees';
import ParentComplaints from './routes/DashboardHome/ParentComplaints';
import Messaging from './routes/Messaging';

const GuardLazy = React.lazy(
	() => import(/* webpackChunkName : 'HomeGuard' */ './Guard')
);

const CurriculumLazyLayout = React.lazy(
	() => import(/* webpackChunkName : 'Curriculum' */ './components/Curriculum')
);

const CurriculumHeaderLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CurriculumHeader' */ './components/MainDashboard'
		)
);

export default (store) => {
	store.injectReducer(NAME, reducer);
	return {
		path: '/:campusId/:curriculumId',
		element: <AsyncLoading component={<GuardLazy />} />,
		children: [
			{
				element: <AsyncLoading component={<CurriculumLazyLayout />} />,
				children: [...Home(store), HomeAnalytics(store), ...MyClasses(store)],
			},
			{
				element: (
					<AsyncLoading
						component={<CurriculumHeaderLazy showFullScreen={true} />}
					/>
				),

				children: [
					...AttendanceDashboard(store),
					...Circular(store),
					...GradeBook(store),
					...HomeTimeTable(store),
					...Insights(store),
					...TeacherNotes(store),
					...Messaging(),
				],
			},
			ClassDetails(store),
			...StudentsListRoute(store),
			...Transport(store),
			...Fees(store),
			...MediaLog(store),
			...ParentComplaints(store),
		],
	};
};
